"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noop = void 0;
const noop = () => ({});
exports.noop = noop;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJub29wIiwiZXhwb3J0cyJdLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9ub29wLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBub29wOiAoKSA9PiB2b2lkID0gKCkgPT4gKHt9KVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBTyxNQUFNQSxJQUFnQixHQUFHQSxDQUFBLE1BQU8sQ0FBQyxDQUFDLENBQUM7QUFBQUMsT0FBQSxDQUFBRCxJQUFBLEdBQUFBLElBQUEiLCJpZ25vcmVMaXN0IjpbXX0=